import request from '@/util/request';
import * as qiniu from 'qiniu-js';
import nanoid from 'nanoid';

/**
 * 文件上传方法，使用 七牛SDK 进行上传，覆盖 el-upload 的默认上传方法
 * @param {Object} option - 包含下列属性：
 * {
 *      headers: 使用 el-upload 组件提供的 headers 属性
 *      withCredentials: 使用 el-upload 组件提供的 headers 属性
 *      file: 添加到浏览器的 file 对象
 *      data: 使用 el-upload 组件提供的 data 属性
 *      filename: 使用 el-upload 组件提供的 name 属性
 *      action: 使用 el-upload 组件提供的 action 属性
 *      onProgress: 使用 el-upload 组件提供的 onProgress 属性
 *      onSuccess: 使用 el-upload 组件提供的 onSuccess 属性
 *      onError: 使用 el-upload 组件提供的 onError 属性
 *  }
 */
function getFileDomain(): string {
  const configuredDomain = process.env.VUE_APP_QINIU_FILE_URL || 'file.reersoft.cn';
  const domain = /^https?:\/\//i.test(configuredDomain)
    ? configuredDomain
    : `https://${configuredDomain}`;
  return `${domain.replace(/\/+$/, '')}/`;
}

const domainUrl = getFileDomain();
export default function(option: any) {
  return new Promise((resolve, reject) => {
    request.get('/gapi/qiniu/put-token').then((token) => {
      const { file } = option;
      let key = nanoid();
      if (file.name.lastIndexOf('.') > -1) {
        key += file.name.substr(file.name.lastIndexOf('.'));
      }
      const observable = qiniu.upload(file, key, token, {
        fname: file.name
      }, {
        useCdnDomain: true,
        // The local bucket is hosted in Qiniu's z0 region. Supplying the
        // region avoids qiniu-js calling api.qiniu.com for region discovery,
        // which is blocked by the local development origin's CORS policy.
        region: qiniu.region.z0,
      });
      observable.subscribe({
        next(res: qiniu.Next): void {
          option.onProgress(res.total, file);
        },
        error(err: qiniu.Error | string): void {
          reject(err)
        },
        complete(res: qiniu.CompletedResult): void {
          console.log('complete: ', res);
          resolve({
            name: file.name,
            // url: `https://pubimg.gelse.cn/${key}`
            url: `${domainUrl}${key}`
          })
        }
      })
    });
  });
}
